module.exports = __webpack_public_path__ + "img/wechat-qrcode.aebd08a9.jpeg";